type CountryCode = string | null | undefined;

// English names, to match the formatted_address that Google gives a country location.
const COUNTRY_NAMES = new Intl.DisplayNames(['en'], { type: 'region', fallback: 'none' });

const toCountryLocation = (countryCode: CountryCode) => {
  const name = countryCode && /^[A-Z]{2}$/.test(countryCode) ? COUNTRY_NAMES.of(countryCode) : undefined;
  if (!countryCode || !name) {
    return null;
  }

  const location = {
    city: null,
    country: countryCode,
    formatted_address: name,
    google_location: null,
    latitude: null,
    longitude: null,
    postal_code: null,
    region: null,
    state: null,
    street1: null,
  };

  return { type: 'country' as const, location };
};

/**
 * The recruit location a new study starts with: the team billing country, else the user profile country.
 * Returns no location when neither is a known country, so the Recruit page asks the user for one.
 */
export const getDefaultRecruitLocations = ({
  billingCountry,
  profileCountry,
}: {
  billingCountry: CountryCode;
  profileCountry: CountryCode;
}) => {
  const location = toCountryLocation(billingCountry) ?? toCountryLocation(profileCountry);
  return location ? [location] : [];
};
